<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<!-- eslint-disable quotes -->
<template lang="pug">
.success-view.container
  Breadcrumbs
  .title-success-view.col-12
    h1 Parabéns! Sua solicitação foi enviada com sucesso!
  .description-sucess-view.col-12
    p Você receberá um e-mail com a aprovação de seu Certificado e com as instruções
      |
      | para a Instalação!
  .col-12.mt-4(style='height: 20rem')
    img.fly(
      :class='[classFly ? "fly-finish" : ""]',
      alt='Solicitação enviada com sucesso',
      src='@/assets/images/success-view.svg'
    )
  .col-12
    .button-to-homepage.mt-4
      router-link.btn.btn-primary(to='/')
        Icon.me-2(name='house', style='font-size: 1.2rem')
        span Voltar para home
  contact
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Input from '@/components/Atoms/Input.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Breadcrumbs from '@/components/Molecules/Breadcrumbs.vue'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    name: 'SuccessView',
    components: {
      Input,
      Contact,
      Icon,
      Breadcrumbs,
    },
    data: () => ({
      classFly: false,
      subdomain: '',
    }),
    computed: {
      ...mapState(useAR, ['arData']),
      routeHome() {
        return this.arData.subdomain || ''
      },
    },
    mounted() {
      const domain = localStorage.getItem('arData')
      if (domain) {
        this.subdomain = JSON.parse(domain).subdomain
      }
      setTimeout(() => {
        this.classFly = true
      }, 100)
    },
  })
</script>

<style lang="stylus" scoped>
  .success-view
    overflow: hidden
  .fly-finish
    position: relative !important
    left: 0 !important
    bottom: 0 !important

  .fly
    position: relative
    bottom: -200rem
    left: -200rem
    transition: all 1.5s

  @media screen and (max-width: 575px)
    .success-view.container
      .title-success-view
        text-align: start
      .description-sucess-view
        text-align: start
</style>
